import React, { createContext, useContext, useState, useCallback } from 'react';
import { api } from '../lib/api';

const AdminAuthContext = createContext(null);

export const useAdminAuth = () => {
  const context = useContext(AdminAuthContext);
  if (!context) {
    throw new Error('useAdminAuth must be used within an AdminAuthProvider');
  }
  return context;
};

export const AdminAuthProvider = ({ children }) => {
  // Read JWT from AuthContext's localStorage key (ourday_token) first,
  // then fall back to legacy sessionStorage key (admin_token)
  const [token, setToken] = useState(
    () => localStorage.getItem('ourday_token') || sessionStorage.getItem('admin_token')
  );
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => !!(localStorage.getItem('ourday_token') || sessionStorage.getItem('admin_token'))
  );
  const [loginError, setLoginError] = useState(null);

  const login = useCallback(async (password) => {
    try {
      setLoginError(null);
      const result = await api.login(password);
      setToken(result.token);
      // Store in both locations for compatibility
      localStorage.setItem('ourday_token', result.token);
      sessionStorage.setItem('admin_token', result.token);
      setIsAuthenticated(true);
      return true;
    } catch (err) {
      setLoginError(err.message);
      return false;
    }
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    localStorage.removeItem('ourday_token');
    sessionStorage.removeItem('admin_token');
    setIsAuthenticated(false);
  }, []);

  return (
    <AdminAuthContext.Provider value={{ token, isAuthenticated, login, logout, loginError }}>
      {children}
    </AdminAuthContext.Provider>
  );
};
